import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/illustration-working.svg'


const _hoisted_1 = { class: "grid lg:flex pb-10 lg:mt-5 mt-2 lg:-mb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex transform scale-175 xs:scale-125 dl:scale-105 dl:pl-0 pl-24 xs:my-5 mx-auto my-16 lg:my-2 lg:order-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "grid lg:w-3/5 lg:pl-40 px-5 lg:text-left justify-items-center lg:justify-items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "xl:text-5xl text-4xl font-black text-very-dark-violet mt-10 lg:mt-28 mb-3 lg:mb-0 px-10 lg:px-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "leading-tight" }, [
    /*#__PURE__*/_createTextVNode("More than just "),
    /*#__PURE__*/_createElementVNode("span", null, " shorter links")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "lg:pb-2 pb-5 lg:px-0 px-5 font-semibold lg:text-xl text-grayish-violet" }, " Build your brand’s recognition and get detailed insights on how your links are performing. ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Get Started")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_buttons = _resolveComponent("buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_buttons, { name: "full" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}